/* global window */
import $ from 'jquery';

$('.js-table-office-open').change(function changeValue() {
	const day = $(this).attr('data-day');
	$(`#${day}-from`).prop('readonly', !$(this).is(':checked'));
	$(`#${day}-to`).prop('readonly', !$(this).is(':checked'));
});

$('.js-time').datetimepicker({
	format: 'LT',
	locale: 'cs',
	widgetPositioning: {
		horizontal: 'right',
		vertical: 'auto',
	},
});



// WEBPACK FOOTER //
// ./js/pages/table-office.js